// extracted by mini-css-extract-plugin
module.exports = {"liveNowIcon":"t7nur"};